import { createApi } from "@reduxjs/toolkit/query/react";
import googleReservationAxiosQuery from "../../utils/axios/googleEmail.axios";
import { IEmailReservations } from "../../interfaces/reservations/IEmailReservations";

export const googleReservationsAPI = createApi({
  reducerPath: "googleReservations",
  baseQuery: googleReservationAxiosQuery(),
  tagTypes: ["googleReservations", "token"],
  endpoints: (builder) => ({
    getAllDraftsEmail: builder.mutation<IEmailReservations, string>({
      query: (accessToken: string) => ({
        url: `/agent-reservations/get-summay-emails?accessToken=${accessToken}`,
        method: "POST",
      }),
	  invalidatesTags: ['token']
    }),

    getAllReservationsEmail: builder.mutation<IEmailReservations, string>({
      query: (accessToken: string) => ({
        url: `/agent-reservations/reservation-email?accessToken=${accessToken}`,
        method: "GET",
      }),
	  invalidatesTags: ['token']
    }),
	getAllGuestIntelligenceEmails: builder.mutation<IEmailReservations, string>({
		query: (accessToken: string) => ({
		  url: `/agent-reservations/opera-reservation-email?accessToken=${accessToken}`,
		  method: "GET",
		}),
		invalidatesTags: ['token']
	  }),
	getAllInvoicesEmail: builder.mutation<IEmailReservations, string>({
		query: (accessToken: string) => ({
		  url: `/agent-reservations/emails?accessToken=${accessToken}`,
		  method: "GET",
		}),
	  }),
    getOutlookCredentials: builder.query<
      { accessToken: string; refreshToken: string },
      void
    >({
      query: () => ({
        url: `/outlook/credentials`,
        method: "GET",
      }),
    }),
	getOutlookTokenFromCode: builder.mutation<
      { accessToken: string; refreshToken: string },
      string
    >({
      query: (code) => ({
        url: `/outlook/callback?code=${code}`,
        method: "GET",
      }),
    }),
	outlookLogout: builder.mutation<
      void,
      void
    >({
      query: () => ({
        url: `/agent-reservations/logout-session`,
        method: "POST",
		data: {}
      }),
	  invalidatesTags: ['token']
    }),
  }),
});

export const {
  useGetAllDraftsEmailMutation,
  useGetAllReservationsEmailMutation,
  useGetAllInvoicesEmailMutation,
  useGetOutlookCredentialsQuery,
  useGetOutlookTokenFromCodeMutation,
  useOutlookLogoutMutation,
  useGetAllGuestIntelligenceEmailsMutation
} = googleReservationsAPI;
